import { render, staticRenderFns } from "./email-description-partial.vue?vue&type=template&id=60bd49f8"
import script from "./email-description-partial.vue?vue&type=script&lang=js"
export * from "./email-description-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports